import { FormControl, MenuItem, Select } from "@mui/material";
import { Controller } from "react-hook-form";

const disabledInputSx = {
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#010a1a",
    },
};

export const ControlledVatDropdown = (props) => {
    const { control, fieldName, readOnly = false } = props;

    const vatOptions = [
        { value: 0, label: "0%" },
        { value: 8, label: "8%" },
        { value: 23, label: "23%" },
    ];

    return (
        <Controller
            name={fieldName}
            control={control}
            render={({ field }) => {
                const isValueListed = vatOptions.some((option) => option.value === field.value);
                return (
                    <FormControl sx={{ minWidth: "100px" }} disabled={readOnly}>
                        <Select
                            {...field}
                            value={field.value || 0}
                            variant="outlined"
                            sx={readOnly ? disabledInputSx : undefined}
                        >
                            {!isValueListed && (
                                <MenuItem value={field.value}>{field.value}%</MenuItem>
                            )}
                            {vatOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            }}
        />
    );
};
